import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getJobTrack = createAsyncThunk('getjobtrackStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingJobTrackDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllJobApplications`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(jobtrackDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(jobtrackDetailClear())
                message.error(error) 
            })
    }
)


export const updateJobtrackStatus = createAsyncThunk('getStatusStatistics',
    async (object, { dispatch, getState }) => {

        const { userToken } = checkAuthorization()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({ id: object?.id, status: object?.status })
        };
        fetch(domainUrl + `/updateJobApplicationStatus`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    const data = result?.data;
                    dispatch(jobtrackstatusResponse({id: data?.id, status: data?.status}))
                }
                else
                    throw result?.message
            })
            .catch(error => {
                message.error(error)
            })
    }
)


const GetJobTrackApiSlice = createSlice({
    name: 'JobtrackgetApi',
    initialState: {
        jobtrackData: null,
        loadingtrackjob: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
            id: '',
            status: '',
        },
    },
    reducers: {
        gettingJobTrackDetail: state => {
            state.loadingtrackjob=true
            state.jobtrackData=null
        },
        jobtrackDetailResponse: (state, action)=>{
            state.jobtrackData= action.payload
            state.loadingtrackjob= false
        },
        jobtrackDetailClear: (state)=>{
            state.jobtrackData= null
            state.loadingtrackjob= false
        },
        changeJobTrackDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        jobtrackstatusResponse: (state, action) => {
            const { id, status } = action.payload
            const trackIndex = state.jobtrackData.findIndex(jb => jb.id === id)
            if (trackIndex !== -1) {
                state.jobtrackData[trackIndex].status = status
            }
            state.loadingtrackjob = false
        }
    },
})
export const { 
    gettingJobTrackDetail, jobtrackDetailResponse, jobtrackDetailClear,
    changeJobTrackDetailFilters, setPages, jobtrackstatusResponse
} = GetJobTrackApiSlice.actions;
export default GetJobTrackApiSlice.reducer;